export default class MouvementStockProduitInfosController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'MouvementStockService',
		'PaginationService',
		'notification',
		'$translate',
		'moment',
		'ModalService'
	];

	constructor($scope, $state, $uibModal, MouvementStockService, PaginationService, notification, $translate, moment, ModalService) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.MouvementStockService = MouvementStockService;
		this.PaginationService = PaginationService;
		this.notification = notification;
		this.$translate = $translate;
		this.moment = moment;
		this.ModalService = ModalService;
		this.loading = false;
		this.unregister = [];
	}

	async $onInit() {
		await this.loadInfos();

		this.unregister.push(
			this.$scope.$watch(
				() => this.mouvementProduitInfos.date,
				async (newValue, oldValue) => {
					if (newValue !== oldValue) {
						await this.loadInfos();
					}
				}
			)
		);
	}

	async $onDestroy() {
		this.unregister.forEach((fn) => fn());
	}

	async loadInfos() {
		this.startLoading();
		try {
			this.movementsStockProduit = await this.MouvementStockService.getMouvementsStockProduitInfosByDay(
				this.idRegoupementSite,
				this.idProduit,
				this.idProducteur,
				this.mouvementProduitInfos.date
			);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
